import createSvgIcon from "@material-ui/icons/utils/createSvgIcon";
import React from "react";

const OrderedListIcon = createSvgIcon(
  <>
    <path d="M0 12.9214H2V13.3979H1V14.351H2V14.8275H0V15.7806H3V11.9683H0V12.9214ZM1 4.34359H2V0.53125H0V1.48433H1V4.34359ZM0 7.20284H1.8L0 9.20432V10.0621H3V9.10901H1.2L3 7.10754V6.24976H0V7.20284ZM5 1.48433V3.3905H19V1.48433H5ZM5 14.8275H19V12.9214H5V14.8275ZM5 9.10901H19V7.20284H5V9.10901Z" />
  </>,
  "OrderedListIcon"
);

export default OrderedListIcon;
